/**
 * Duplicate Accounts merge UI gate (single toggle for admin Home + route).
 * Set to false to hide the hub entry until Ops is ready.
 */
const DUPLICATE_ACCOUNTS_MERGE_UI_ON = true;

export const DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE =
  "This feature is in testing and development. It is not available for use yet and will be released when it is ready.";

export function isDuplicateAccountsMergeUiEnabled() {
  return DUPLICATE_ACCOUNTS_MERGE_UI_ON;
}
